export const flowVasActionTypes = {
  GET_FLOW_VAS: 'GET_FLOW_VAS',
  GET_FLOW_VAS_EXITO: 'GET_FLOW_VAS_EXITO',
  GET_FLOW_VAS_ERRROR: 'GET_FLOW_VAS_ERRROR'
}
